import { extend } from 'underscore';

export const getDisclaimerStyles = ({
  styleOverrides,
}: {
  styleOverrides?: {
    additionalLineDisclaimer?: object;
    popupDisclaimer?: object;
    disclaimerCallout?: object;
  };
}) => (e: Error | null, { palette = {} }: { palette?: { themePrimary?: string } }) => ({
  additionalLineDisclaimer: extend({

    color: palette.themePrimary,
    fontSize: '13px',
    lineHeight: '24px',
    paddingLeft: '2px',
  }, styleOverrides.additionalLineDisclaimer),

  popupDisclaimer: extend({
    '& .disclaimer-title': {
      backgroundColor: 'white',
      color: '#767676',
      fontSize: '13px',
      lineHeight: '24px',
      textDecoration: 'underline',
      paddingLeft: '2px',
      border: 'none',
    },
  }, styleOverrides.popupDisclaimer),

  disclaimerCallout: extend({
    '& .ms-Callout-main': {
      width: '250px',
      padding: '15px',
    },
    '& button.close': {
      backgroundColor: 'white',
      border: 'none',
      float: 'right',
      marginTop: '-7px',
    },
    '& .title': {
      color: '#767676',
      marginBottom: '10px',
    },
    '& .content': {
      marginBottom: '3px',
    },
    '& .disclaimer-url': {

      color: palette.themePrimary,
      fontSize: '13px',
      lineHeight: '24px',
    },
  }, styleOverrides.disclaimerCallout),
});
